import React, {
  memo,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { AgGridReact } from "ag-grid-react";
import {
  AllCommunityModule,
  ModuleRegistry,
  themeQuartz,
  RowStyleModule
} from "ag-grid-community";
import { ColumnMenuModule,MasterDetailModule } from "ag-grid-enterprise";
ModuleRegistry.registerModules([AllCommunityModule, ColumnMenuModule,MasterDetailModule,RowStyleModule]);

const myTheme = themeQuartz.withParams({
  backgroundColor: "#173666",
  headerBackgroundColor: "rgb(228, 237, 250)",
  // rowColor: "#fff",
  rowHoverColor: "#173666",

});

const setPrinterFriendly = (api) => {
  const eGridDiv = document.querySelector("#myGrid");
  if (eGridDiv) {
    eGridDiv.style.width = "";
    eGridDiv.style.height = "";
    api.setDomLayout("print");
  } else {
    console.error("Grid container not found: #myGrid");
  }
};

const setNormal = (api) => {
  const eGridDiv = document.querySelector("#myGrid");
  if (eGridDiv) {
    eGridDiv.style.width = "700px";
    eGridDiv.style.height = "200px";
    api.setDomLayout(null);
  } else {
    console.error("Grid container not found: #myGrid");
  }
};
function GridTable({ data, colDefs, down = true, height = "100vh",detailCellRendererParams={},rowClassRules={} }) {
  const [filterData, setFilterData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const gridStyle = useMemo(() => ({ height: height, width: "100%" }), []);
  const gridRef = useRef();
  const defaultColDef = useMemo(() => {
    return {
      floatingFilter: true,
    };
  }, []);

  const pagination = true;
  const paginationPageSize = 20;
  const paginationPageSizeSelector = [20, 50, 100];
  const onBtnExport = useCallback(() => {
    gridRef.current.api.exportDataAsCsv();
  }, []);

  const onBtPrint = useCallback(() => {
    setPrinterFriendly(gridRef.current.api);
    setTimeout(() => {
      window.print();
      setNormal(gridRef.current.api);
    }, 2000);
  }, [window.print]);

  useEffect(() => {
    if (data) {
      setFilterData(data);
    }
  }, [data]);

  const handleSearchChange = (event) => {
    const query = event.target.value;
    if (query.length <= 50 && data) {
      setSearchQuery(query);
      const filtered = data?.filter((item) =>
        Object.values(item).some((value) => {
          return (
            (typeof value === "string" &&
              value.toLowerCase().includes(query.toLowerCase())) ||
            (typeof value === "number" && value.toString().includes(query))
          );
        })
      );
      setFilterData(filtered);
    }
  };

  const onFirstDataRendered = useCallback((params) => {
    // Expand the first available row (index 0 or 1)
    const rowNode = params.api.getDisplayedRowAtIndex(1); // or 0
    if (rowNode) {
      rowNode.setExpanded(false); // or false depending on desired default state
    }
  }, []);

  return (
    <>
      <div className=" mb-3">
        {down && (
          <div className="text-end d-flex justify-content-end  ">
            <div className="col-md-5 d-inline-flex">
              <input
                type="text"
                class="form-control me-2 "
                placeholder="Search"
                value={searchQuery}
                onChange={handleSearchChange}
              />
              <button onClick={onBtPrint} className="btn btn2 btn_icon">
                <i class="bi bi-printer"></i>
              </button>
              <button onClick={onBtnExport} className="ms-2 btn btn2 btn_icon">
                <i class="bi bi-filetype-csv"></i>
              </button>
            </div>
          </div>
        )}
      </div>
      <div style={gridStyle}>
        <AgGridReact
          ref={gridRef}
          suppressExcelExport={true}
          rowData={filterData}
          columnDefs={colDefs}
          defaultColDef={defaultColDef}
          pagination={pagination}
          paginationPageSize={paginationPageSize}
          paginationPageSizeSelector={paginationPageSizeSelector}
          enableCellTextSelection={true}
          suppressRowClickSelection={true}
          theme={myTheme}
          suppressMoveWhenColumnDragging={true}
          suppressDragLeaveHidesColumns={true}
          masterDetail={true}
          detailCellRendererParams={detailCellRendererParams}
          onFirstDataRendered={onFirstDataRendered}
          rowClassRules={rowClassRules}
        />
      </div>
    </>
  );
}

export default memo(GridTable);
